// services
import './services/authentication.es6';
import './services/before-action.es6';
import './services/configured-restangular.es6';
import './services/confirm-action.es6';
import './services/ga.es6';
import './services/impact-point-constants.es6';
import './services/login-type.es6';
import './services/resource.es6';
import './services/shared-state.es6';
import './services/swing-type-constants.es6';
import './services/video-parser.es6';
// components
import './components/bread-crumb.es6';
import './components/date-picker.es6';
import './components/sss-resize.es6';
import './components/resize.es6';

// controllers
import './controllers/root-controller.es6';
import './controllers/home-controller.es6';

// 生徒
import './components/member-sign-in/member-sign-in-controller.es6';
import './components/member-top/member-top-controller.es6';
import './components/lesson-detail/lesson-detail-controller.es6';
import './components/lesson-detail/graph.es6';
import './components/video/play/video-play-screen.es6';

// スタッフ
import './components/coach-sign-in/coach-sign-in-controller.es6';
import './components/school-list/school-list-controller.es6';
import './components/coach-top/coach-top-controller.es6';
import './components/guest-video/guest-video-controller.es6';
import './components/course-detail/course-detail-controller.es6';
import './components/member-detail/member-detail-controller.es6';
import './components/video-backlog/video-backlog-controller.es6';

// ダイアログ
import './components/dialog/advertise/dialog-advertise-controller.es6';
import './components/dialog/interim-password/dialog-interim-password-controller.es6';
import './components/dialog/select-shot/dialog-select-shot-controller.es6';
import './components/dialog/sign-out/dialog-sign-out-controller.es6';
import './components/dialog/delete-video/dialog-delete-video-controller.es6';
import './components/dialog/move-video-to-guest/dialog-move-video-to-guest-controller.es6';

// Video
import './components/video/upload/video-upload.es6';
import './components/video/guest/video-guest.es6';

// 共通
import './components/eula/eula-controller.es6';
import './components/password-forget/password-forget-controller.es6';
import './components/password-change/password-change-controller.es6';
import './components/simplicity-sign-in/simplicity-sign-in-controller.es6';
import './components/notification-configration/notification-configration-controller.es6';

// Admin
import './components/admin-coach-list/admin-coach-list-controller.es6';
import './components/admin-member-list/admin-member-list-controller.es6';
import './components/admin-top/admin-top-controller.es6';
import './components/admin-school-list/admin-school-list-controller.es6';
import './components/admin-course-list/admin-course-list-controller.es6';

// parts
import './components/personal-card/personal-card-controller.es6';

// lib
import './lib/common-auth.es6';
import './lib/common-api.es6';
import './lib/common.es6';
import './lib/tennis-shot-data-view.es6';

import './components/title/title.es6';



// WEBPACK FOOTER //
// ./app/app.entry.es6